import { QUIZ, STORYBOARD, PREP_CHECKLIST, MAKING_STEPS, EVAL_CRITERIA } from "./content";

export const filled = (v) => typeof v === "string" && v.trim().length > 0;

export const quizScore = (answers) => QUIZ.filter((q) => answers[q.id] === q.correct).length;
export const QUIZ_PASS = 2;

export const assembleScript = (m4) => [m4.hook, m4.demo, m4.conclusion].filter(filled).map((t) => t.trim()).join("\n\n");

export const scriptStats = (text) => {
  const words = text.split(/\s+/).filter(Boolean).length;
  const seconds = Math.round(words / 2.5);
  let label = "Pas encore de texte";
  if (words > 0 && seconds < 15) label = "Plutôt court — tu peux développer un peu";
  else if (seconds >= 15 && seconds <= 45) label = "Durée idéale pour une première vidéo";
  else if (seconds > 45 && seconds <= 60) label = "Un peu long — essaie de resserrer";
  else if (seconds > 60) label = "Long — garde l'essentiel";
  return { words, seconds, label };
};

const missingFields = (obj, fields) => fields.filter(([k]) => !filled(obj[k])).map(([, label]) => label);
const countTrue = (map, list) => list.filter((i) => map[i.id]).length;

export const REQUIREMENTS = {
  1: (s) => (s.m1.submitted && quizScore(s.m1.answers) >= QUIZ_PASS ? [] : ["Réussir le quiz (au moins 2 bonnes réponses sur 3)"]),
  2: (s) =>
    missingFields(s.m2, [
      ["name", "Nom du produit"],
      ["category", "Catégorie"],
      ["why", "Pourquoi je l'ai choisi"],
      ["utility", "Son utilité principale"],
      ["detail", "Le détail que je veux montrer"],
    ]),
  3: (s) =>
    [!filled(s.m3.angle) && "Choisir un angle"].filter(Boolean).concat(
      missingFields(s.m3, [
        ["audience", "À qui s'adresse mon produit"],
        ["situation", "La situation d'utilisation"],
        ["show", "Ce que je vais montrer"],
        ["benefit", "Le bénéfice concret"],
        ["idea", "L'idée principale"],
      ])
    ),
  4: (s) => missingFields(s.m4, [["hook", "L'accroche"], ["demo", "La démonstration"], ["conclusion", "La conclusion"]]),
  5: (s) => PREP_CHECKLIST.filter((i) => !s.m5.checklist[i.id]).map((i) => i.label),
  6: (s) => MAKING_STEPS.filter((i) => !s.m6.steps[i.id]).map((i) => `Étape : ${i.label}`),
  7: (s) =>
    EVAL_CRITERIA.filter((c) => !s.m7.evals[c.id])
      .map((c) => `Évaluer : ${c.label}`)
      .concat(
        missingFields(s.m7, [
          ["strengths", "Mes points forts"],
          ["improvements", "Mes améliorations"],
          ["learned", "Ce que j'ai appris"],
        ])
      ),
};

export const isDone = (s, id) => !!s.completed[id] && REQUIREMENTS[id](s).length === 0;

const hasData = (v) => {
  if (typeof v === "string") return v.trim().length > 0;
  if (typeof v === "boolean") return v;
  if (v && typeof v === "object") return Object.values(v).some(hasData);
  return false;
};

export const missionStatus = (s, id) => (isDone(s, id) ? "done" : hasData(s[`m${id}`]) ? "progress" : "todo");

export const doneCount = (s) => [1, 2, 3, 4, 5, 6, 7].filter((id) => isDone(s, id)).length;

export const resumeMission = (s) => [1, 2, 3, 4, 5, 6, 7].find((id) => !isDone(s, id)) || 7;

export const filmedCount = (s) => countTrue(s.m5.filmed, STORYBOARD);
export const prepCount = (s) => countTrue(s.m5.checklist, PREP_CHECKLIST);
export const stepsCount = (s) => countTrue(s.m6.steps, MAKING_STEPS);
